<app-dialog-heading [heading]="'Concessions'"></app-dialog-heading>

<div class="dialog-content">
  <form [formGroup]="form">
    <div class="flex items-center justify-between py1"
         *ngFor="let type of data.underwritingTypes"
         [formGroupName]="type.value">
      <div class="flex-auto m-r-10">
        <app-element-slide-toggle
          [label]="type.name"
          formControlName="enabled"
          (valueChanged)="onToggleConcession($event, type.value)">
        </app-element-slide-toggle>
      </div>

      <div class="w-50" *ngIf="form.get(type.value.toString())?.get('enabled')?.value">
        <app-element-date-range
          formControlName="dateRange"
          [minDate]="getMinimumStartDatePerType(type.value)"
          [disabled]="false">
        </app-element-date-range>
      </div>
    </div>
  </form>

  <mat-dialog-actions align="center" class="dialog-button-container mt3">
    <div class="flex justify-center">
      <button class="dialog-button mr2" mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
      <button class="dialog-button"
              mat-raised-button
              color="primary"
              [disabled]="isSaveDisabled()"
              (click)="onSave()">Okay</button>
    </div>
  </mat-dialog-actions>
</div>
